module.exports = __webpack_public_path__ + "media/styles/images/svg/inline-arrow-down-gray-light-0d736a90ce94dd1b1ffe49d92f11af4e.svg";